import React from "react";
import "../../assets/styles/newSolutions.css";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import { motion } from "framer-motion";
import Bulb from "../../assets/images/bulb.png";

const NewSolution = () => {
     const navigate = useNavigate(); 
  return (
    <div className="newsolutions-container">
      <div className="container">
        <div className="row align-items-center">
          {/* Left Side - Image */}
          <div className="col-md-5 text-center mb-4 mb-md-0 newImgClass">
            <motion.img
              src={Bulb} 
              alt="Lightbulb Icon"
              className="img-fluid"
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 1 }}
            />
          </div>

          {/* Right Side - Text and Button */}
          <div className="col-md-7 text-center text-md-start">
            <motion.h2
              className="text-lime"
              initial={{ opacity: 0, y: -20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1 }}
            >
              SOLUTIONS
            </motion.h2>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1, delay: 0.2 }}
              className="newSolutions-description"
            >
              Expertise you can rely on. With a focus on the bigger picture, we
              <span className="hide-on-mobile">
                <br />
              </span>
              provide the insights,
              <span className="hide-on-mobile">
                <br />
              </span>{" "}
              guidance, and solutions that meet today’s needs while driving you
              <span className="hide-on-mobile">
                <br />
              </span>{" "}
              toward your future
              <span className="hide-on-mobile">
                <br />
              </span>{" "}
              goals.
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 1.2, ease: "easeInOut", delay: 0.4 }}
              whileHover={{ scale: 1.1 }}
              onClick={() => navigate("/solutions")}
            >
              <Button variant="dark" className="custom-button">
                SOLUTIONS
              </Button>
            </motion.div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewSolution;
